import React from "react";

export function DataTable({ columns, rows, empty="No records yet", testid="data-table" }) {
  return (
    <div className="linkedin-card overflow-hidden" data-testid={testid}>
      <div className="overflow-x-auto">
        <table className="w-full text-left">
          <thead className="bg-[#F4F2EE] border-b border-[#E0DFDC]">
            <tr>
              {columns.map((c) => (
                <th key={c.key} className="text-[11px] font-semibold text-[#00000099] uppercase tracking-wider p-3">{c.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={columns.length} className="p-8 text-center text-sm text-[#00000099]">{empty}</td></tr>
            )}
            {rows.map((r, i) => (
              <tr key={r.id || i} className="data-row border-b border-[#E0DFDC] last:border-b-0" data-testid={`${testid}-row-${i}`}>
                {columns.map((c) => (
                  <td key={c.key} className="p-3 text-sm text-[#000000E6] align-middle">
                    {c.render ? c.render(r) : (r[c.key] ?? "—")}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    active: "#057642", paid: "#057642", present: "#057642", Admitted: "#057642",
    partial: "#915907", pending: "#915907", Interested: "#915907", Demo: "#915907",
    due: "#CC1016", absent: "#CC1016", Lost: "#CC1016",
    New: "#0A66C2",
  };
  const color = map[status] || "#00000099";
  return (
    <span className="text-[11px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded"
      style={{color, background: `${color}18`}}>
      {status}
    </span>
  );
}
